// extracted by mini-css-extract-plugin
module.exports = {"shortDesc":"MarketplaceV3LoadsSection_shortDesc__1y7nr"};